import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { translate, I18n } from "@td/shared_utils";
import { Button } from "@td/ui";
import { Formik, Form } from "formik";
import { NotesField } from "../fields";
import { defaultTaskNotesFormValue, fieldTypes } from "../constants";
import { createTaskNote } from "../apis";
import NoteList from "./NoteList";
import { NotesFieldContainer } from "../components";
import toastr from "../../toastr";

const Notes = ({ taskId, notes }) => {
  const [createdTaskNotes, setCreatedTaskNotes] = useState([]);

  const handleSubmit = useCallback(async ({ notes: note }, { resetForm }) => {
    const { taskNote } = await createTaskNote({
      note,
      taskId,
    });

    if (taskNote) {
      setCreatedTaskNotes([
        taskNote,
        ...createdTaskNotes,
      ]);

      resetForm();
    }
  }, [taskId, createdTaskNotes, setCreatedTaskNotes]);

  return (
    <React.Fragment>
      <Formik
        initialValues={defaultTaskNotesFormValue}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form>
            <NotesFieldContainer>
              <NotesField />
              <Button
                type="submit"
                disabled={!values[fieldTypes.NOTES]}
              >
                <I18n scope="care_team_tasks.form.fields.notes" text="add_button" />
              </Button>
            </NotesFieldContainer>
          </Form>
        )}
      </Formik>

      <NoteList
        notes={[...createdTaskNotes, ...notes]}
      />
    </React.Fragment>
  );
};

Notes.propTypes = {
  taskId: PropTypes.string.isRequired,
  notes: PropTypes.array.isRequired,
};

export default Notes;
